import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonFilter from "../../common/CommonFilter";
import { useSearchParams } from "react-router-dom";
import { saveAdvancedSelectedFilters } from "../../actionCreator/companyListingActionCreater";
import { Col, Collapse, Row } from "antd";
import {
  Info,
  Layers,
  MapPin,
  Globe,
  Map,
  Building,
  Factory,
  Building2,
  Users,
  DollarSign,
  Tag,
  ChevronUp,
  ChevronDown,
  Save,
} from "lucide-react";
import { AuthContext } from "../../context/AuthContext";

const AdvancedFilter = ({
  isModal,
  openAdvancedModel,
  showCheckAll = true,
  setOpenAdvancedModel,
  showNumberofRecords = null,
}) => {
  const { isAuthenticated } = useContext(AuthContext);
  const companyFilterList = useSelector((state) => state.companyListingReducer);
  const companySelectedFilterList = useSelector(
    (state) => state.companyListingReducer.selectedFilters,
  );

  const companyFilterListIndustry = useSelector(
    (state) => state.companyListingReducer.industryList,
  );

  const companyFilterListCompanyType = useSelector(
    (state) => state.companyListingReducer.companyTypeList,
  );

  const companyFilterListEmployeeCountList = useSelector(
    (state) => state.companyListingReducer.employeeCountList,
  );

  const companyFilterListRevenueRangeList = useSelector(
    (state) => state.companyListingReducer.revenueRangeList,
  );

  const companyFilterListCities = useSelector(
    (state) => state.companyListingReducer.geoLocation?.cities,
  );
  const companyFilterListCountries = useSelector(
    (state) => state.companyListingReducer.geoLocation?.countries,
  );
  const companyFilterListStates = useSelector(
    (state) => state.companyListingReducer.geoLocation?.states,
  );

  const companyFilterListSavedSearch = useSelector(
    (state) => state.companyListingReducer.saveSearchList,
  );

  const companyFilterListTags = useSelector(
    (state) => state.DashboardReducer.companyTags,
  );

  const [visibleFilter, setVisibleFilter] = useState({
    country: false,
    state: false,
    city: false,
    industry: false,
    companyType: false,
    employeeCount: false,
    revenue: false,
    savedSearch: false,
    companyTag: false,
  });
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [selectedStateList, setSelectedStateList] = useState([]);
  const [selectedCountryList, setSelectedCountryList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [active, setActive] = useState(isModal ? ["company-info"] : []);

  useEffect(() => {
    const allParams = {};
    for (const [key, value] of searchParams.entries()) {
      allParams[key] = value;
    }
    dispatch(
      saveAdvancedSelectedFilters({
        selectedCountry: allParams?.Countries?.split(","),
        selectedState: allParams?.States?.split(","),
        selectedCity: allParams?.Cities?.split(","),
        selectedIndustry: allParams?.Industry?.split(","),
        selectedCompanytype: allParams?.["Company Type"]?.split(","),
        selectedEmployeecount: allParams?.["Employee Count"]?.split(","),
        selectedRevenuerange: allParams?.["Revenue Range"]?.split(","),
        searchKeyword: allParams?.searchKeyword,
        selectedCompanyTag: allParams?.Tags?.split(","),
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!selectedStateList?.length) {
      setCitiesList(
        selectedCountryList?.length
          ? companyFilterList?.geoLocation?.cities.filter((city) => {
              return selectedCountryList
                ?.map((d) => ({
                  ...companyFilterList?.geoLocation?.countries?.find(
                    (i) => i?.name === d,
                  ),
                }))
                ?.some((ct) => {
                  return ct?.country_id === city?.country_id;
                });
            })
          : companyFilterList?.geoLocation?.cities,
      );
    } else {
      //By Nawedita
      const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
        return selectedStateList
          ?.map((d) => ({
            ...companyFilterList?.geoLocation?.states?.find(
              (i) => i?.name === d,
            ),
          }))
          ?.some((ct) => {
            return (
              ct.state_id === city?.state_id &&
              ct?.country_id === city?.country_id
            );
          });
      });

      setCitiesList(cityList);
    }
  }, [selectedStateList]);

  useEffect(() => {
    if (!selectedCountryList?.length) {
      setStatesList(companyFilterList?.geoLocation?.states);
    } else {
      //By Nawedita
      const cityList = companyFilterList?.geoLocation?.states.filter((city) => {
        return selectedCountryList
          ?.map((d) => ({
            ...companyFilterList?.geoLocation?.countries?.find(
              (i) => i?.name === d,
            ),
          }))
          ?.some((ct) => {
            return ct.country_id === city?.country_id;
          });
      });
      setStatesList(cityList);
    }
  }, [selectedCountryList]);

  useEffect(() => {
    setCitiesList(companyFilterListCities);
  }, [companyFilterListCities]);

  useEffect(() => {
    setStatesList(companyFilterListStates);
  }, [companyFilterListStates]);

  useEffect(() => {
    setSelectedStateList(companySelectedFilterList.selectedState);
    setSelectedCountryList(companySelectedFilterList?.selectedCountry);
  }, [companySelectedFilterList]);

  const openVisibleFilter = (menu) => {
    setVisibleFilter({
      ...{
        country: false,
        state: false,
        city: false,
        industry: false,
        companyType: false,
        employeeCount: false,
        revenue: false,
        utility: false,
        pages: false,
        savedSearch: false,
        companyTag: false,
      },
      [menu]: !visibleFilter[menu],
    });
  };

  const onCountriesChange = (list) => {
    updateStateBasedOnCountry(list);
  };

  const updateStateBasedOnCountry = (list) => {
    const stateList = companyFilterList?.geoLocation?.states.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return ct.country_id === city?.country_id;
          })
        : companyFilterList?.geoLocation?.states;
    });

    setStatesList(stateList);

    const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return ct?.country_id === city?.country_id;
          })
        : companyFilterList?.geoLocation?.cities;
    });
    setCitiesList(cityList);
  };

  const filterCountry = (ele) => {
    setSelectedCountryList([]);
  };

  /*Countries Start */
  const showCountriesList = () => {
    return (
      <CommonFilter
        isModal={isModal}
        title="Countries"
        icon={<Globe size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListCountries}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        onDataChange={onCountriesChange}
        onSearch={filterCountry}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("country")}
        isShow={visibleFilter.country}
      />
    );
  };

  /*Countries End */

  /*State Start */
  const showStatesList = () => {
    return (
      <CommonFilter
        title="States"
        isModal={isModal}
        icon={<Map size={16} className="tw-text-slate-500" />}
        dataList={statesList}
        onSearch={filterState}
        onDataChange={onStatesChange}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("state")}
        isShow={visibleFilter.state}
      />
    );
  };

  const filterState = (ele) => {
    setSelectedStateList([]);
  };

  const onStatesChange = (list) => {
    updateCityBasedOnState(list);
  };

  const updateCityBasedOnState = (list) => {
    const cityList = companyFilterList?.geoLocation?.cities.filter((city) => {
      return list?.length
        ? list.some((ct) => {
            return (
              ct.state_id === city?.state_id &&
              ct?.country_id === city?.country_id
            );
          })
        : companyFilterList?.geoLocation?.cities;
    });
    setCitiesList(cityList);
  };

  /*state End */

  /* City Start */
  const showCitiesList = () => {
    return (
      <CommonFilter
        title="Cities"
        isModal={isModal}
        icon={<Building size={16} className="tw-text-slate-500" />}
        dataList={citiesList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("city")}
        isShow={visibleFilter.city}
      />
    );
  };

  /*City End */

  /*Industry Start */
  const showIndustryList = () => {
    return (
      <CommonFilter
        title="Industry"
        isModal={isModal}
        icon={<Factory size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListIndustry}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("industry")}
        isShow={visibleFilter.industry}
      />
    );
  };

  /*Industry End */

  /*start companytype */
  const showCompanyTypeList = () => {
    return (
      <CommonFilter
        title="Company Type"
        isModal={isModal}
        icon={<Building2 size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListCompanyType}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("companyType")}
        isShow={visibleFilter.companyType}
      />
    );
  };

  /*End companytype */

  /*start employee count */
  const showEmployeeCountList = () => {
    return (
      <CommonFilter
        title="Employee Count"
        isModal={isModal}
        icon={<Users size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListEmployeeCountList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("employeeCount")}
        isShow={visibleFilter.employeeCount}
      />
    );
  };

  /*End employee count */

  /*Start revenue range */
  const showRevenueRangeList = () => {
    return (
      <CommonFilter
        title="Revenue Range"
        isModal={isModal}
        icon={<DollarSign size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListRevenueRangeList}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("revenue")}
        isShow={visibleFilter.revenue}
      />
    );
  };

  /*End revenue range */

  /*Start Search List */
  const showSaveSearchList = () => {
    return (
      <CommonFilter
        title="Saved Search"
        isModal={isModal}
        icon={<Save size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListSavedSearch?.map((d) => ({
          ...d,
          name: d?.fullName,
        }))}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={false}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("savedSearch")}
        isShow={visibleFilter.savedSearch}
      />
    );
  };

  /*End Search List */

  /*Start Company Tag List */
  const showCompanyTagList = () => {
    return (
      <CommonFilter
        title="Tags"
        isModal={isModal}
        icon={<Tag size={16} className="tw-text-slate-500" />}
        dataList={companyFilterListTags}
        showNumberofRecords={showNumberofRecords}
        showCheckAll={showCheckAll}
        setOpenAdvancedModel={setOpenAdvancedModel}
        openVisibleFilter={() => openVisibleFilter("companyTag")}
        isShow={visibleFilter.companyTag}
      />
    );
  };

  const filterRenderMap = {
    Countries: { id: "county", render: showCountriesList },
    States: { id: "state", render: showStatesList },
    Cities: { id: "city", render: showCitiesList },
    Industry: { id: "industry", render: showIndustryList },
    "Company Type": { id: "companyType", render: showCompanyTypeList },
    "Employee Count": { id: "emplyeeCount", render: showEmployeeCountList },
    "Revenue Range": { id: "revenueRange", render: showRevenueRangeList },
    "Saved Search": { id: "savedsearch", render: showSaveSearchList },
    Tags: { id: "companyTag", render: showCompanyTagList },
  };

  const renderJsx = () => {
    const selectedKey = openAdvancedModel?.key;

    if (filterRenderMap[selectedKey]) {
      const { id, render } = filterRenderMap[selectedKey];
      return (
        <div className="filterblk" id={id}>
          {render()}
        </div>
      );
    }

    // Default rendering when no specific key is matched
    return (
      <>
        {isModal ? (
          <>
            <Row className="tw-bg-white tw-border-t tw-border-b tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-100">
              <Col
                xs={8}
                className="tw-p-4 tw-flex tw-flex-col tw-gap-2 tw-bg-slate-50/50 tw-border-t-0 tw-border-b-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-slate-100 tw-font-inter"
              >
                <div className="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400 tw-mb-2">
                  Filter Categories
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("company-info") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["company-info"]);
                  }}
                >
                  <Building2 size={16} className={active?.includes("company-info") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Company Info
                </div>
                <div
                  className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("location") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                  onClick={() => {
                    setActive(["location"]);
                  }}
                >
                  <MapPin size={16} className={active?.includes("location") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                  Location
                </div>
                {isAuthenticated && (
                  <div
                    className={`tw-cursor-pointer tw-text-sm tw-flex tw-items-center tw-gap-2.5 tw-rounded-lg tw-font-semibold tw-py-2.5 tw-px-3 tw-transition-all tw-duration-150 ${active?.includes("classification") ? "tw-bg-[#EFEAFF] tw-text-[#5D44FF] tw-shadow-sm" : "tw-text-slate-600 hover:tw-bg-slate-100/50 hover:tw-text-slate-800"}`}
                    onClick={() => {
                      setActive(["classification"]);
                    }}
                  >
                    <Layers size={16} className={active?.includes("classification") ? "tw-text-[#5D44FF]" : "tw-text-slate-400"} />
                    Classification
                  </div>
                )}
              </Col>
              <Col
                xs={16}
                className="tw-p-4 tw-max-h-[400px] tw-overflow-y-auto"
              >
                {active?.includes("classification") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(filterRenderMap)
                      .filter(([key]) => ["Saved Search", "Tags"].includes(key))
                      .map(([key, { id, render }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "classification",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-gap-2 tw-pl-3">
                                    {key}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div className="filterblk">{render()}</div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                ) : active?.includes("location") ? (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(filterRenderMap)
                      .filter(([key]) =>
                        ["Countries", "States", "Cities"].includes(key),
                      )
                      .map(([key, { id, render }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "location",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                                    {key}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div className="filterblk">{render()}</div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-1">
                    {Object.entries(filterRenderMap)
                      .filter(([key]) =>
                        [
                          "Industry",
                          "Company Type",
                          "Employee Count",
                          "Revenue Range",
                        ].includes(key),
                      )
                      .map(([key, { id, render }]) => (
                        <div id={id} key={key}>
                          <Collapse
                            className="tw-advanced-filter"
                            expandIcon={({ isActive }) =>
                              isActive ? <ChevronUp size={16} className="tw-text-slate-500" /> : <ChevronDown size={16} className="tw-text-slate-500" />
                            }
                            expandIconPosition="end"
                            items={[
                              {
                                key: "company-info",
                                label: (
                                  <div className="tw-text-sm tw-font-semibold  tw-flex tw-items-center tw-gap-2 tw-pl-3">
                                    {key}
                                  </div>
                                ),
                                children: (
                                  <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                                    <div
                                      className="filterblk"
                                      id={id}
                                      key={key}
                                    >
                                      {render()}
                                    </div>
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                  </div>
                )}
              </Col>
            </Row>
          </>
        ) : (
          <div className="tw-p-1 tw-flex tw-flex-col tw-gap-2">
            <Collapse
              defaultActiveKey={active}
              onChange={(val) => {
                setActive(
                  !val?.length
                    ? [...active?.filter((d) => d !== "company-info")]
                    : [...active, val[0]],
                );
              }}
              className={
                active?.includes("company-info") ? "tw-filter-collapse" : ""
              }
              ghost={!active?.includes("company-info")}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <ChevronUp size={16} className="tw-text-slate-500" />
                ) : (
                  <ChevronDown size={16} className="tw-text-slate-500" />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "company-info",
                  label: (
                    <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                      <Building2 size={16} className="tw-text-slate-500" />
                      Company Information
                    </div>
                  ),
                  children: (
                    <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                      {Object.entries(filterRenderMap)
                        .filter(([key]) =>
                          [
                            "Industry",
                            "Company Type",
                            "Employee Count",
                            "Revenue Range",
                          ].includes(key),
                        )
                        .map(([key, { id, render }]) => (
                          <div className="filterblk" id={id} key={key}>
                            {render()}
                          </div>
                        ))}
                    </div>
                  ),
                },
              ]}
            />
            <Collapse
              defaultActiveKey={active}
              onChange={(val) => {
                setActive(
                  !val?.length
                    ? [...active?.filter((d) => d !== "location")]
                    : [...active, val[0]],
                );
              }}
              className={
                active?.includes("location") ? "tw-filter-collapse" : ""
              }
              ghost={!active?.includes("location")}
              expandIcon={({ isActive }) =>
                isActive ? (
                  <ChevronUp size={16} className="tw-text-slate-500" />
                ) : (
                  <ChevronDown size={16} className="tw-text-slate-500" />
                )
              }
              expandIconPosition="end"
              items={[
                {
                  key: "location",
                  label: (
                    <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                      <MapPin size={16} className="tw-text-slate-500" />
                      Location
                    </div>
                  ),
                  children: (
                    <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                      {Object.entries(filterRenderMap)
                        .filter(([key]) =>
                          ["Countries", "States", "Cities"].includes(key),
                        )
                        .map(([key, { id, render }]) => (
                          <div className="filterblk" id={id} key={key}>
                            {render()}
                          </div>
                        ))}
                    </div>
                  ),
                },
              ]}
            />
            {isAuthenticated && (
              <Collapse
                defaultActiveKey={active}
                onChange={(val) => {
                  setActive(
                    !val?.length
                      ? [...active?.filter((d) => d !== "classification")]
                      : [...active, val[0]],
                  );
                }}
                className={
                  active?.includes("classification") ? "tw-filter-collapse" : ""
                }
                ghost={!active?.includes("classification")}
                expandIcon={({ isActive }) =>
                  isActive ? (
                    <ChevronUp size={16} className="tw-text-slate-500" />
                  ) : (
                    <ChevronDown size={16} className="tw-text-slate-500" />
                  )
                }
                expandIconPosition="end"
                items={[
                  {
                    key: "classification",
                    label: (
                      <div className="tw-text-sm tw-flex tw-items-center tw-gap-2">
                        <Layers size={16} className="tw-text-slate-500" />
                        Classification
                      </div>
                    ),
                    children: (
                      <div className="tw-flex tw-flex-col tw-gap-1 tw-pb-1">
                        {Object.entries(filterRenderMap)
                          .filter(([key]) =>
                            ["Saved Search", "Tags"].includes(key),
                          )
                          .map(([key, { id, render }]) => (
                            <div className="filterblk" id={id} key={key}>
                              {render()}
                            </div>
                          ))}
                      </div>
                    ),
                  },
                ]}
              />
            )}
          </div>
        )}
      </>
    );
  };

  return <>{renderJsx()}</>;
};

export default AdvancedFilter;
